/** Canonical site origin; set `BUN_PUBLIC_SITE_URL` for production (no trailing slash). */
export function getSiteUrl(): string {
  const raw =
    typeof process !== "undefined" && process.env.BUN_PUBLIC_SITE_URL
      ? process.env.BUN_PUBLIC_SITE_URL.trim()
      : "";
  const base = raw.replace(/\/$/, "");
  return base || "https://alanviles.nz";
}

export const SITE_DEFAULT_DESCRIPTION =
  "Alan Viles builds embedded systems, electronics, and software. Engineering student at the University of Canterbury, Christchurch.";

export const SITE_OG_IMAGE_PATH = "/DSC_6043_square.jpg";
